export default __webpack_public_path__ + "static/tipsplay-9b0c600c21e226502c413f89212c18e3.png";